import React from 'react';
import {
  Box,
  Button,
  Flex,
  Text,
  Image,
  Input,
  Grid,
  Textarea,
  Heading,
} from '@chakra-ui/react';
import { starFrame } from '../../assets/exports';

const ContactUs = () => {
  return (
    <Box>
      <Flex alignItems="center" gap="12px">
        <Grid
          placeItems="center"
          bgColor="#7B47CC"
          color="#ffff"
          borderRadius="6px"
          px="16px"
          h="50px"
        >
          <Heading fontWeight={500} fontSize={['18px', '24px', '28px', '36px']}>
            Contact Us
          </Heading>
        </Grid>
        <Text>Connect with Us: </Text>
      </Flex>
      <Box
        borderRadius="20px"
        my="66px"
        minW="100%"
        minH="fit-content"
        pb={{ base: '43px', md: '70px' }}
        bgGradient="linear(to-l, #F9F3EE,#F2ECF8)"
      >
        <Box px={[5, 10, 10, '5rem']} pos="relative" pt="55px">
          <Flex
            w="100%"
            gap="2rem"
            flexDir={{ base: 'column', md: 'row' }}
            justifyContent="space-between"
          >
            <Box w={['100%', '100%', '100%', '65%']}>
              <Flex
                gap="13px"
                justifyContent={{ base: 'center', md: 'unset' }}
                mb="38px"
              >
                <Flex
                  rounded="full"
                  justifyContent="center"
                  placeItems="center"
                  border="1px solid #000000"
                  w="26px"
                  bg="#fff"
                  h="26px"
                >
                  <Flex
                    rounded="full"
                    border="1px solid #000000"
                    w="15px"
                    bg="#7B47CC"
                    h="15px"
                  ></Flex>
                </Flex>
                <Text>Say Hi</Text>
              </Flex>
              <Flex flexDir="column" gap="23px">
                <Box>
                  <Text>Name</Text>
                  <Input
                    h="56px"
                    placeholder="Name"
                    border="1px solid #DADADA"
                  />
                </Box>
                <Box>
                  <Text>Email*</Text>
                  <Input
                    h="56px"
                    placeholder="Email"
                    border="1px solid #DADADA"
                  />
                </Box>
                <Box>
                  <Text>Message*</Text>
                  <Textarea h="180px" border="1px solid #DADADA" />
                </Box>
              </Flex>
              <Button
                h="65px"
                color="#ffff"
                bgColor="#0F172B"
                mt="38px"
                w="full"
              >
                Send Message
              </Button>
            </Box>

            <Box
              pos="relative"
              right={0}
              display={{ base: 'none', md: 'flex' }}
              flexDir="column"
            >
              <Box mt="auto" ml="auto">
                <Image src={starFrame} />
              </Box>
            </Box>
          </Flex>
        </Box>
      </Box>
    </Box>
  );
};

export default ContactUs;
